const pillars = [
  {
    letter: "M",
    title: "Marketing",
    description:
      "Posicionamento, comunicação, autoridade e atração com direção. Marca pensada com clareza estratégica, não com agressividade comercial.",
  },
  {
    letter: "A",
    title: "Autoconhecimento",
    description:
      "Postura, clareza, maturidade e evolução profissional. O alicerce comportamental que sustenta a presença e a decisão.",
  },
  {
    letter: "C",
    title: "Ciência do Cabelo",
    description:
      "Técnica, diagnóstico, responsabilidade e resultado. Base sólida de conhecimento aplicado, sem atalhos e sem modismo.",
  },
  {
    letter: "D",
    title: "Desenvolvimento Cognitivo Comportamental",
    description:
      "Comportamento, decisão, liderança, relacionamento e crescimento. O profissional que cresce porque pensa antes de reagir.",
  },
];

export const MACD = () => {
  return (
    <section
      id="macd"
      data-testid="macd-section"
      className="bg-[#0a0a0a] text-white py-28 md:py-40 relative overflow-hidden"
    >
      <div className="absolute inset-0 opacity-[0.04] bg-grain pointer-events-none" />
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-end">
          <div className="lg:col-span-7 reveal">
            <div className="flex items-center gap-4 mb-8">
              <span className="rule-yellow" />
              <span className="eyebrow text-white/60">Metodologia autoral</span>
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-[3.6rem] leading-[1.05] tracking-tight">
              MACD: uma metodologia
              <br />
              para formar profissionais{" "}
              <em className="italic text-[#f4c542]">completos</em>.
            </h2>
          </div>
          <div className="lg:col-span-5 reveal">
            <p className="text-base md:text-lg leading-relaxed text-white/75 max-w-md lg:ml-auto">
              Mais que técnica, o MACD desenvolve o cabeleireiro em quatro
              dimensões. Quatro pilares, uma única direção: o profissional
              preparado para o novo momento do setor.
            </p>
          </div>
        </div>

        <div className="mt-20 md:mt-28 grid grid-cols-1 md:grid-cols-2 gap-px bg-white/10 border border-white/10">
          {pillars.map((p, idx) => (
            <div
              key={p.letter}
              data-testid={`macd-pillar-${p.letter.toLowerCase()}`}
              className="bg-[#0a0a0a] p-10 md:p-14 reveal group hover:bg-[#131313] transition-colors duration-500"
              style={{ transitionDelay: `${idx * 60}ms` }}
            >
              <div className="flex items-start gap-8">
                <span className="font-display text-[5rem] md:text-[6.5rem] leading-none text-[#f4c542] group-hover:text-[#ffd85a] transition-colors">
                  {p.letter}
                </span>
                <div className="flex-1 pt-3">
                  <p className="eyebrow text-white/50">
                    Pilar {String(idx + 1).padStart(2, "0")}
                  </p>
                  <h3 className="font-display text-2xl md:text-3xl mt-3 leading-snug">
                    {p.title}
                  </h3>
                  <p className="mt-5 text-[15px] md:text-base leading-relaxed text-white/75 max-w-md">
                    {p.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 md:mt-20 flex flex-col md:flex-row md:items-end md:justify-between gap-6 reveal">
          <p className="font-display italic text-2xl md:text-3xl text-white/90 max-w-2xl leading-snug">
            &ldquo;O profissional que cresce com método não decide por sensação.
            Decide com base em padrão.&rdquo;
          </p>
          <p className="eyebrow text-white/50">— Direção Oasys Academy</p>
        </div>
      </div>
    </section>
  );
};
